import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  return (
    <section id="faq" className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center">
          <span className="text-xs md:text-sm font-medium tracking-wide text-primary-600">
            常见问题
          </span>
          <h3 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于匿名投稿，你可能想先弄清楚这几件事
          </h3>
        </div>

        <div className="mt-8 md:mt-10 space-y-3">
          {faqs.map((faq) => {
            const isOpen = faq.id === openId;
            return (
              <div
                key={faq.id}
                className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? "" : faq.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i
                      className={`text-lg text-foreground-500 transition-transform duration-300 ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}